/* eslint-disable no-undef */
/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
//import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from "./ns-event-button.html";
import { events } from "@nuskin/ns-util";
import "@nuskin/ns-style-elements";

/**
 * <p>The ns-event-button can be used on Sales Event landing pages as an entry point to the Sales Event shopping page when the event opens.</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-event-button theme="secondary" event-name="blackFriday"></ns-event-button>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *  </script>
 * </marked-element>
 *
 */
export class NsEventButton extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-event-button";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * 'short' option will make the button more compact
       */
      size: {
        type: String
      },
      /**
       * Changes the style of the button. Options include:
       * `primary`, `primary-inverse`,
       * `secondary`, `secondary-inverse`, `secondary-outline`,
       * `primary-hit`, `secondary-hit`, `tertiary-hit`
       */
      theme: {
        type: String
      },
      /**
       * The name of the sales event this button waits for.
       */
      eventName: {
        type: String
      },
      /**
       * Text displayed on the button while it is disabled waiting for the sales event.
       */
      preEventText: {
        type: String,
        value: "Waiting For Event"
      },
      /**
       * Text displayed on the button when the button is enabled allowing access to the sales event.
       */
      inEventText: {
        type: String,
        value: "Enter Event"
      },
      /**
       * Text displayed on the button when the button is enabled allowing access to the sales event.
       */
      postEventText: {
        type: String,
        value: "Event Is Over"
      },
      /**
       */
      pausedEventText: {
        type: String,
        value: "Event is paused"
      }
    };
  }

  ready() {
    super.ready();

    this.disabled = true;
    this.buttonText = this.preEventText;
    this._initListeners();
    events.publish(events.salesevent.POLL_MARKET_CONFIG, [this.eventName]);
    if (this.eventName) {
      events.publish(events.salesevent.INIT_EVENT_TICKET, [this.eventName]);
    }
  }

  /**
   * This is the handler when the button gets clicked.
   */
  enterSalesEvent() {
    events.publish(events.salesevent.GO_TO_EVENT_PAGE, [this.eventName]);
  }

  _initListeners() {
    events.getValue(events.salesevent.PRE_EVENT, this._processPreEvent(this), true);
    events.getValue(events.salesevent.IN_EVENT, this._processInEvent(this), true);
    events.getValue(
      events.salesevent.POST_EVENT,
      this._processPostEvent(this),
      true
    );
    events.getValue(
      events.salesevent.MARKET_CONFIG_EVENTS,
      (mktConfigEvents) => {
        if (mktConfigEvents) {
          if (!this.eventName || !mktConfigEvents.includes(this.eventName)) {
            this.buttonText = `${this.eventName} is not configured`;
          }
        }
      },
      true
    );
  }

  _processPreEvent(_scope) {
    let scope = _scope;

    return (eventName, paused) => {
      if (eventName === scope.eventName) {
        console.log(
          "BUTTON Received PRE Event for:",
          eventName,
          "This eventName",
          scope.eventName
        );
        scope.disabled = true;
        scope.buttonText = paused ? scope.pausedEventText : scope.preEventText;
      }
    };
  }

  _processInEvent(_scope) {
    let scope = _scope;

    return (eventName, paused) => {
      if (eventName === scope.eventName) {
        console.log(
          "BUTTON Received IN Event for:",
          eventName,
          "This eventName",
          scope.eventName
        );
        scope.disabled = paused === true;
        scope.buttonText = paused ? scope.pausedEventText : scope.inEventText;
      }
    };
  }

  _processPostEvent(_scope) {
    let scope = _scope;

    return (eventName) => {
      if (eventName === scope.eventName) {
        console.log(
          "BUTTON Received POST Event for:",
          eventName,
          "This eventName",
          scope.eventName
        );
        scope.disabled = true;
        scope.buttonText = scope.postEventText;
      }
    };
  }
}

customElements.define(NsEventButton.is, NsEventButton);
